
<script setup>

import {Link} from "@inertiajs/inertia-vue3";
import Indicator from "@admin_ui/Pages/Products/Table/Indicator";
import Label from "@common/TableFields/Label";
import Money from "@common/Form/Money";
import {PencilAltIcon , TrashIcon} from "@heroicons/vue/solid";
import Confirmation from "@common/Confirmation";
import {ref , reactive , watch , computed } from "vue";
import {Inertia} from "@inertiajs/inertia";
import Input from "@common/Form/Input";
import Select from "@common/Form/Select";
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/vue/solid'
import {pickBy , throttle} from "lodash";
import ToggleSwitch from "@common/Form/ToggleSwitch";
import ProductBulkUpsellUpdater from "@admin_ui/Pages/Products/Table/ProductBulkUpsellUpdater";
import DeviceSchedule from "@admin_ui/Pages/Products/Table/DeviceSchedule";
import {onMounted} from "vue";
import {useBreadStore} from '@bread/js/store'
import Device from "@admin_ui/Pages/Devices/Device";

const props = defineProps({
  products : Object,
  activeProducts : Number,
  filters : Object,
  categories : Array,
  aisles : Array,
  devices : Array,
  stores : Array,
  currentStore : Object,
  storesSync : Boolean,
})

const store = useBreadStore()



const params = reactive({
  search : props.filters.search,
  field : props.filters.field,
  direction : props.filters.direction,
  category : props.filters.category,
  aisle : props.filters.aisle,
  is_new : props.filters.is_new,
  active : props.filters.active,
  store : props.currentStore.id,
})


const getFilteredProducts = () => {
  let activeParams = pickBy(params);
  Inertia.visit(route('admin.products.index',activeParams),
    {  preserveState:true ,replace : true , only:['products','currentStore']});
}

watch(params , throttle((newValue)=>{
  getFilteredProducts();
},300))

const sort = (field)=>{
  params.field = field;
  params.direction = params.direction==='asc' ? 'desc' : 'asc';
}

const isModalVisible = ref(false)
const toDelete = ref(null)
const showFilters = ref(false)

const indicatorOptions = {
  cases : [
    {
      classes:"bg-gray-400",
      title : "nog geen prijs updates",
      value : "grey"
    },
    {
      classes:"bg-green-600",
      title : "laatste update minder dan 2 dagen geleden",
      value : "green"
    },
    {
      classes:"bg-orange-600",
      title : "laatste update minder dan 7 dagen geleden",
      value : "orange"
    },
    {
      classes:"bg-red-600",
      title : "laatste update meer dan 7 dagen geleden",
      value : "red"
    },
  ]}

const statusOptions = {
  cases : [
    {
      classes:"bg-green-600 text-white",
      title : "New",
      value : true
    },
  ]}

const deleteItem = (boolean) => {
  isModalVisible.value = false

  if (boolean === true) {
    form['_method'] = 'delete'
    Inertia.post(route('admin.products.delete', {id: toDelete.value}), form)
  }

  toDelete.value = null
}

const openModal = (item) => {
  isModalVisible.value = true
  toDelete.value = item.id
}

const setIsNewFilter = ()=> {
  params.is_new =  params.is_new === true ? false : true ;
}

const setActiveFilter = ()=> {
  params.active =  params.active === true ? false : true ;
}

const updateUpsellPrice = (data) => {
  Inertia.put(
    route('admin.products.update', {product: data.id}),
    {
      'id': data.id,
      'upsell_price': data.upsell_price,
      'storeId':props.currentStore.id
    },
    {
      preserveScroll: true,
      preserveState:true,
      only:['products','currentStore']
    }
  )
}

const margin = ( product ) => {
  if ( !product.purchase_price || product.purchase_price == 0 ){return '-'}
  let localPrice = parseFloat(product.local_price ?? product.official_price);
  let purchasePrice = parseFloat(product.purchase_price);
  return (((localPrice-purchasePrice)/purchasePrice)*100).toFixed(2).replace('.', ',')+'%';
}

onMounted(() => {
  store.setResource('product')
})



</script>

<template>
  <div>
    <confirmation
      v-if="isModalVisible"
      @onDelete="deleteItem"
    message="Weet je zeker dat je dit product wenst te verwijderen?"
    />
    <div class="max-w-10xl mx-auto">
      <div class="w-full px-4 pt-4 pb-5 sm:flex sm:items-center sm:justify-between">

      </div>
      <div class="w-full px-4 pt-4 pb-5 sm:flex sm:items-center sm:justify-between">
        <h3 class="text-lg font-medium leading-6 text-gray-900">Producten voor {{ currentStore.name }}<br>
          <span v-if="storesSync" class="text-sm text-green-500">Opgelet, alle winkels worden aangepast.</span>
        </h3>
        <div class="flex items-center">
          <div class="flex items-stretch space-x-4">
            <div class="relative inline-flex cursor-pointer items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none rounded-r-md"
            >
              Aantal actieve producten: {{activeProducts}}
            </div>

            <product-bulk-upsell-updater :filters="params"/>
            <device-schedule :devices="devices" />
            <span class="relative z-0 inline-flex rounded-md shadow-sm">
              <div type="button"
                   class="relative inline-flex cursor-pointer items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none rounded-r-md"
                   @click="showFilters = !showFilters"
              >
                Toon Filters
              </div>
            </span>
          </div>
        </div>
      </div>
      <div v-if="showFilters" class="bg-gray-200 rounded-md mb-5">
        <div id="searchfields" class="p-3 grid grid-cols-1 lg:grid-cols-6 gap-4 items-center">
          <Select v-model="params.store" :options="stores.map((store)=>{return {'id' : store.id , 'name' : store.name}})"
                  label="Kies Winkel"
          ></Select>
          <Input label="Product naam"
                 name="name"
                 v-model="params.search"
                 class="col-span-1"
          />
          <Select name="recurring"
                  v-model="params.category"
                  label = "Categorie"
                  :options="categories.map((category)=>{return {'id' : category.category , 'name' : category.category}})"
                  class=" col-span-1"

          />
          <Select name="recurring"
                  v-model="params.aisle"
                  label = "Rayon"
                  :options="aisles.map((aisle)=>{return {'id' : aisle.aisle , 'name' : aisle.aisle}})"
                  class="col-span-1"

          />
          <Select name="recurring"
                  v-model="params.active"
                  label = "Actief"
                  :options="[{id: 0, name: 'Niet actief'}, {id: 1, name: 'Actief'}]"
                  class="col-span-1"

          />
          <div class="col-span-1">
            <ToggleSwitch :value="params.isNew" @toggleStatus="setIsNewFilter"/>
            <label class="ml-4">Nieuw</label>
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="overflow-x-auto shadow-md sm:rounded-lg">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden ">
              <table class="min-w-full divide-y divide-gray-200 table-fixed ">
                <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                     <span @click="sort('hope')" class="inline-flex w-full justify-between cursor-pointer">
                      Hope
                      <ArrowUpIcon v-if="params.field === 'hope' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'hope' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"></th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span @click="sort('last_price_update_at')" class="inline-flex w-full justify-between cursor-pointer">
                      UPDATE STATUS
                      <ArrowUpIcon v-if="params.field === 'last_price_update_at' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'last_price_update_at' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span @click="sort('name')" class="inline-flex w-full justify-between cursor-pointer">
                      PRODUCT
                      <ArrowUpIcon v-if="params.field === 'name' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'name' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span @click="sort('purchase_price')" class="inline-flex w-full justify-between cursor-pointer">
                      INKOOP
                      <ArrowUpIcon v-if="params.field === 'purchase_price' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'purchase_price' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">OFFICIËLE PRIJS</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span @click="sort('upsell_price')" class="inline-flex w-full justify-between cursor-pointer">
                      CORRECTIE
                      <ArrowUpIcon v-if="params.field === 'upsell_price' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'upsell_price' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">NIEUWE PRIJS</th>
                  <th scope="col"
                      class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      title="geschatte jaarlijkse extra winst op basis van huidige correctie"
                  >
                    <span @click="sort('yearly_estimated_upsell_gain')" class="inline-flex w-full justify-between cursor-pointer" title="Extra winst die gecreëerd wordt op jaarbasis door de prijscorrectie door te voeren">
                      WINST MET CORRECTIE
                      <ArrowUpIcon v-if="params.field === 'yearly_estimated_upsell_gain' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'yearly_estimated_upsell_gain' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    <span @click="sort('margin')" class="inline-flex w-full justify-between cursor-pointer">
                      MARGE
                      <ArrowUpIcon v-if="params.field === 'margin' && params.direction === 'asc'" class="h-4 w-4"/>
                      <ArrowDownIcon v-if="params.field === 'margin' && params.direction === 'desc'" class="h-4 w-4"/>
                    </span>
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">RAYON NUMMER</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="(product , index ) in props.products.data" :key="product.id" class="hover:bg-gray-100 " :class="index % 2 === 0 ? undefined : 'bg-gray-50'">
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap " :title="'EAN: ' + product.ean">{{product.hope}}</td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Label
                      :value="product.is_new"
                      :options="statusOptions"
                    />
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Indicator
                      :value="product.store_update_indicator"
                      :options="indicatorOptions"
                    />
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{product.name}}</td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Money :number="product.purchase_price"
                           :id="product.id"
                    :options = "{prefix : '€' , cent_separator:','}"/>
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Money :number="product.official_price"
                           :id="product.id"
                           :options = "{prefix : '€' , cent_separator:','}"/>
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Money :number="product.upsell_price?? 0"
                           :id="product.id"
                           :options = "{cent_separator:','}"
                           :editable = "true"
                           attribute_name="upsell_price"
                           @changed="updateUpsellPrice"
                    />
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Money :number="product.local_price?? 0"
                           :id="product.id"
                           :options = "{prefix : '€' , cent_separator:','}"/>
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">
                    <Money :number="product.yearly_estimated_upsell_gain ?? (product.yearly_potential_upsell_gain ? product.yearly_potential_upsell_gain : 0)"
                           :id="product.id"
                           :class="!product.yearly_estimated_upsell_gain && product.yearly_potential_upsell_gain ? 'text-green-500' :''"
                           :title="!product.yearly_estimated_upsell_gain && product.yearly_potential_upsell_gain ? 'Potentiele jaarlijkse winst bij correctie van €0,20': 'Huidige winst van correctie'"
                           :options = "{prefix : '€' , cent_separator:','}"/>
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{margin ( product )}}</td>
                  <td class="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap ">{{product.aisle.split('-')[0]}}</td>
                  <td class="py-4 px-6 text-sm font-medium text-right whitespace-nowrap space-x-2">
                    <Link
                      :href="
                          route('admin.products.edit', [
                            product.id,
                          ])
                        "
                      class = "text-dark"
                      title="edit"
                    >
                      <!--                    {{ store.translate('edit') }}-->
                      <PencilAltIcon class="action-icons"></PencilAltIcon>
                    </Link>
                    <span class="inline-block">
                        <button
                          @click="openModal(product)"
                          class="text-danger"
                          title="delete"
                        >
                          <TrashIcon class="action-icons text-red-500"></TrashIcon>
                        </button>
                      </span>
                  </td>
                  <td class="py-4 px-6 text-sm font-medium text-right whitespace-nowrap">
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <Link v-if="products.prev_page_url"
              :href="products.prev_page_url"
              :only="['products']"
              class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              preserve-state
              preserve-scroll

        >Vorige</Link>
        <span v-else
              class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-400">Vorige</span>
        <Link v-if="products.next_page_url"
              :href="products.next_page_url"
              :only="['products']"
              class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              preserve-state
              preserve-scroll
        >Volgende</Link>
        <span v-else class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Volgende</span>
      </div>
    </div>
  </div>
</template>



<style scoped>
.action-icons{
  width: 20px;
  height: 20px;
  display: inline-block;
}
</style>
